import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import AssetLevelTable from './AssetLevelTable.component';
import type { EmirFundLevelTableRow } from '../emirFundSummary.types';
import { getEmirTableExportFileName } from '../../../../../../../api/rs-hg/emir';

const AssetLevelTableWrapper = (exportPositionDate?: string) => [
  (rowData: EmirFundLevelTableRow) => {
    const assets = rowData.assets ?? [];
    const icon = () => (assets.length ? <KeyboardArrowRight /> : <></>);
    const exportFileName =
      exportPositionDate && rowData.fundId
        ? getEmirTableExportFileName(
            `asset_level-${rowData.fundId}`,
            exportPositionDate,
          )
        : undefined;
    const render = () => (
      <AssetLevelTable data={assets} exportFileName={exportFileName} />
    );
    return {
      disabled: !assets.length,
      icon,
      openIcon: KeyboardArrowDown,
      render,
    };
  },
];

export default AssetLevelTableWrapper;
